module.exports = __webpack_public_path__ + "img/add-booth.38de69da.svg";